import type {} from './native-platform.js';
import { createCheckoutAttemptId } from './analytics-context.js';

const STORAGE_KEY = 'drawonamap.proCheckoutBrowser';

/** A billing request key, separate from optional analytics identifiers. */
export async function proCheckoutHeaders(): Promise<Headers> {
  const headers = new Headers({ 'Content-Type': 'application/json' });
  if (!('window' in globalThis)) return headers;
  if (window.drawOnAMapNative) headers.set('X-DrawOnAMap-Native', '1');
  const readOrCreate = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && /^[a-f0-9]{64}$/.test(stored)) return stored;
      const key = createCheckoutAttemptId();
      if (key) localStorage.setItem(STORAGE_KEY, key);
      return key;
    } catch { return null; }
  };
  // Web Locks serializes first checkout creation across tabs in this browser.
  const key = navigator.locks
    ? await navigator.locks.request(STORAGE_KEY, readOrCreate)
    : readOrCreate();
  if (key) headers.set('X-Pro-Checkout-Key', key);
  return headers;
}
